import { Box, Tooltip, Typography, useTheme } from "@mui/material";
import { WarningAmberOutlined } from "@mui/icons-material";
import useStyles from "./styles";
import SeverityChip from "../severityChip";

export default function ProblemasTrigger({ problemas = [], cor = "red" }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  // Sem problema ativo não há o que sinalizar no card
  if (!problemas?.length) return null;

  return (
    <Tooltip
      componentsProps={{ tooltip: { sx: styles.tooltip } }}
      title={
        <Box sx={styles.lista}>
          {problemas?.map((problema) => (
            <Box key={problema?.triggerid} sx={styles.linha}>
              <SeverityChip
                severity={String(problema?.prioridade)}
                theme={theme}
              />
              <Typography sx={styles.descricao}>
                {problema?.descricao}
              </Typography>
            </Box>
          ))}
        </Box>
      }
    >
      <WarningAmberOutlined fontSize="small" sx={styles.icone(cor)} />
    </Tooltip>
  );
}
